import { post, get } from '../index'

export const getOrderApi = {
    getOrder(params) {
        return post('order/calculate_new', params)
    },
    getAddordit(params) {
        return post('cart/addoredit', params)
    },
    getEcotact(params) {
        return get('order/econtact')
    },
    setSubmit(params) {
        return post('order/submit', params)
    },
    getOrderLlist(params) {
        return get('order/list', params)
    },
    getOrderCancel(params) {
        return post('order/cancel', params)
    },
    // 余额支付
    getPay(params) {
        return post('pay/pay', params)
    },
    getCouponMylist(params){
        return get('coupon/mylist',params)
    },
    //订单精度
    getOrderExpress(params){
        return get('order/order_express',params)
    },
    // 其他信息
    getInfoList(params){
        return get('info/list',params)
    },
    // 确认收货
    getOrderConfirm(params){
        return post('order/confirm',params)
    },
    // 订单进度
    getOrderProgress(params){
        return get('order/order_progress',params)
    },
    // 返单计价
    orderCalculate(params){
        return post('order/calculate_old',params)
    },
    //商品评价
    orderEvaluation(params){
        return post('comment/add',params)
    },
    // 订单详情
    getOrderDetail(params){
        return get('order/detail',params)
    }
  
}



// WEBPACK FOOTER //
// ./src/api/http/order.js